"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveListFiles = exports.googleDriveListFilesResultSchema = exports.googleDriveListFilesArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveListFilesArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('list-files', zod_1.z.object({
    folderId: zod_1.z
        .string()
        .nullish()
        .describe("The parent folder's id where we want to list the files from (blank for top level)"),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
});
exports.googleDriveListFilesResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(googleDriveFileSchema));
exports.googleDriveListFiles = (0, common_1.createToolMetadata)({
    id: 'googleDriveListFiles',
    displayName: 'Google Drive List Files',
    displayDescription: 'Gets a list of the files on this Google Drive account. Returns all of the users files',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveListFilesArgsSchema,
}, exports.googleDriveListFilesResultSchema);
